import axios from 'axios';

async function sendPasswordResetEmail(email: string): Promise<any> {
  const response = await axios.post(`${process.env.REACT_APP_USER_SESSION_API}/usuarios-ies/solicitar-atualizacao-senha`, {
    email: email,
  });
  return response.data;
}

export default sendPasswordResetEmail;
